import { Component, inject } from '@angular/core';
import { CheckForUpdateService } from './services/check-for-update.service';
import moment from 'moment';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { ICONS } from './consts/icons.const';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [RouterOutlet]
})
export class AppComponent {
  title = 'EstImage Online';
  customIcons: Array<{ iconName: string; iconPath: string }> = ICONS;

  #domSanitizer = inject(DomSanitizer);
  #matIconRegistry = inject(MatIconRegistry);
  #swCheckUpdate = inject(CheckForUpdateService);

  constructor() {
    this.#swCheckUpdate.checkForUpdates();

    if (sessionStorage.getItem('timeZone')) {
      moment.tz.setDefault(sessionStorage.getItem('timeZone'));
    }

    this.customIcons.forEach((icon: { iconName: string; iconPath: string }) => {
      this.#matIconRegistry.addSvgIcon(icon.iconName, this.#domSanitizer.bypassSecurityTrustResourceUrl(icon.iconPath));
    });
  }
}
